<template>
  <div class="asideContianer">
    <el-menu
      :default-active="activeMenu"
      class="el-menu-vertical-demo"
      @open="handleOpen"
      @close="handleClose"
      :collapse="isCollapse"
      background-color="rgb(50, 65, 87)"
      text-color="#fff"
      active-text-color="#ffd04b"
    >
      <div class="brand-block">
        <img class="brand-logo" :src="BRAND.sidebarLogoUrl || BRAND.logoUrl" />
        <h3 :style="{ color: BRAND.primaryColor }">{{ isCollapse ? BRAND.sidebarShortTitle : BRAND.sidebarTitle }}</h3>
      </div>

      <el-menu-item
        v-for="item in noChildren"
        :key="item.path || item.name"
        :index="item.path || item.name"
        @click="clickMenu(item)"
      >
        <i :class="`el-icon-${item.icon}`"></i>
        <span slot="title">{{ item.label }}</span>
      </el-menu-item>

      <el-submenu
        v-for="item in hasChildren"
        :key="item.path || item.name"
        :index="item.path || item.name"
      >
        <template slot="title">
          <i :class="`el-icon-${item.icon}`"></i>
          <span slot="title">{{ item.label }}</span>
        </template>
        <el-menu-item-group
          style="margin-left:40px"
          v-for="subItem in item.children"
          :key="subItem.path || subItem.name"
        >
          <el-menu-item :index="subItem.path || subItem.name" @click="clickMenu(subItem)">{{ subItem.label }}</el-menu-item>
        </el-menu-item-group>
      </el-submenu>
    </el-menu>
  </div>
</template>

<script>
import BRAND from '@/config/brand'

const LOCAL_NOTE_MENU = {
  name: 'memo',
  label: '备忘录',
  icon: 'notebook-1',
  children: [
    {
      name: 'note',
      label: '笔记',
      path: '/note',
    },
  ],
}

const LOCAL_WAREHOUSE_MENU = {
  parentName: 'ckmd',
  parentLabel: '仓库管理',
  fallbackIcon: 'office-building',
  children: [
    {
      name: 'stockCheck',
      label: '库存盘点',
      path: '/stockCheck',
    },
    {
      name: 'stockTransfer',
      label: '库存调拨',
      path: '/stockTransfer',
    },
  ],
}

const LOCAL_INSIGHT_MENU = {
  name: 'insight',
  label: '经营分析',
  icon: 'data-analysis',
  children: [
    {
      name: 'warningCenter',
      label: '预警中心',
      path: '/warningCenter',
    },
    {
      name: 'reportCenter',
      label: '经营报表',
      path: '/reportCenter',
    },
  ],
}

const LOCAL_GROUP_INJECTIONS = [LOCAL_WAREHOUSE_MENU]
const LOCAL_EXTRA_MENUS = [LOCAL_NOTE_MENU, LOCAL_INSIGHT_MENU]

export default {
  name: 'Aside',
  data() {
    return {
      menuData: [],
    }
  },
  computed: {
    BRAND() {
      return BRAND
    },
    displayMenus() {
      return this.appendLocalMenus(this.menuData)
    },
    noChildren() {
      return this.displayMenus.filter(item => !item.children || !item.children.length)
    },
    hasChildren() {
      return this.displayMenus.filter(item => item.children && item.children.length)
    },
    isCollapse() {
      return this.$store.state.tab.isCollapse
    },
    activeMenu() {
      return this.$route.path === '/' ? '/index' : this.$route.path
    },
  },
  methods: {
    InitMenu() {
      this.menuData = []
      this.$http.get('/menu/getShowMenu').then(res => {
        this.menuData = res.data.data || []
      }).catch(() => {
        this.menuData = []
      })
    },
    handleOpen() {},
    handleClose() {},
    clickMenu(item) {
      if (this.$route.path != item.path && !(this.$route.path === '/index' && item.path === '/')) {
        this.$router.push(item.path)
      }
      this.$store.commit('menuChange', item)
    },
    menuPathExists(menuList, path) {
      if (!path || !menuList || !menuList.length) {
        return false
      }
      return menuList.some(item => {
        if (item.path === path) {
          return true
        }
        if (item.children && item.children.length) {
          return this.menuPathExists(item.children, path)
        }
        return false
      })
    },
    cloneMenus(menuList) {
      return (menuList || []).map(item => {
        const nextItem = Object.assign({}, item)
        if (item.children && item.children.length) {
          nextItem.children = this.cloneMenus(item.children)
        }
        return nextItem
      })
    },
    findMenuGroup(menuList, menuGroup) {
      return (menuList || []).find(item => item.name === menuGroup.parentName || item.label === menuGroup.parentLabel)
    },
    appendGroupChildren(menuList) {
      LOCAL_GROUP_INJECTIONS.forEach(menuGroup => {
        const targetGroup = this.findMenuGroup(menuList, menuGroup)
        if (!targetGroup) {
          return
        }
        const localChildren = menuGroup.children.filter(item => !this.menuPathExists(menuList, item.path))
        if (!localChildren.length) {
          return
        }
        const currentChildren = Array.isArray(targetGroup.children) ? targetGroup.children.slice() : []
        targetGroup.children = currentChildren.concat(localChildren)
      })
      return menuList
    },
    appendLocalMenus(menuList) {
      const mergedMenus = this.appendGroupChildren(this.cloneMenus(menuList))
      LOCAL_EXTRA_MENUS.forEach(menu => {
        const localChildren = menu.children.filter(item => !this.menuPathExists(mergedMenus, item.path))
        if (localChildren.length) {
          mergedMenus.push(Object.assign({}, menu, { children: localChildren }))
        }
      })
      return mergedMenus
    },
  },
  mounted() {
    this.InitMenu()
  },
}
</script>

<style lang="less" scoped>
.asideContianer {
  height: 100%;
}

.el-menu {
  height: 100%;
  border-right: none;
  overflow-y: auto;
  overflow-x: hidden;

  .brand-block {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    padding: 12px 14px 8px;
  }

  .brand-logo {
    width: 32px;
    height: 32px;
    border-radius: 8px;
    object-fit: cover;
    background: rgba(255,255,255,0.9);
    flex-shrink: 0;
  }

  h3 {
    color: #fff;
    text-align: center;
    line-height: 32px;
    font-size: 20px;
    font-weight: 500;
    padding: 0;
    margin: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/common/Aside.vue